/* QUIETUDE — tiroir panier.
   Les libellés et le format monétaire ne sont plus écrits ici : ils sont lus
   sur #drawer, où snippets/qt-cart.liquid les pose (data-empty, data-remove,
   data-currency, data-locale, data-free). Avant, le tiroir redessinait ses lignes en
   anglais sur le site français, et formatait tout en euros même sur les
   marchés en livres, en francs et en dollars. Les valeurs de repli gardent
   l'ancien comportement si l'attribut manque.

   L'état vide rend maintenant un lien vers le catalogue à la suite de sa
   phrase (data-empty-cta, data-empty-href) : le tiroir s'ouvre vide après un
   retrait de dernière ligne, et il n'y avait alors plus rien à y faire. Le
   pied, lui, disparaît — is-empty, posée ici à chaque redessin comme Liquid
   la pose au chargement. */
(function () {
  if (window.__qtDrawerBound) return;
  window.__qtDrawerBound = true;

  var NBSP = " ", MINUS = "−";

  function root() { return document.getElementById("drawer"); }

  function conf(name, fallback) {
    var d = root();
    var v = d && d.getAttribute("data-" + name);
    return v && v.length ? v : fallback;
  }

  var fmt = null;
  function money(cents) {
    var cur = conf("currency", "");
    if (cur) {
      if (!fmt) {
        try {
          fmt = new Intl.NumberFormat(conf("locale", document.documentElement.lang || "fr"),
                                      { style: "currency", currency: cur });
        } catch (e) { fmt = null; }
      }
      if (fmt) return fmt.format(cents / 100);
    }
    return (cents / 100).toFixed(2).replace(".", ",") + NBSP + "€";
  }

  function setCount(n) {
    document.querySelectorAll(".cart-count, .hy-count, .mm-count").forEach(function (c) { c.textContent = n; });
  }

  function open(state) {
    var drawer = root(), scrim = document.getElementById("scrim");
    if (!drawer) return;
    drawer.classList.toggle("on", state);
    if (scrim) scrim.classList.toggle("on", state);
    drawer.setAttribute("aria-hidden", String(!state));
    document.documentElement.style.overflow = state ? "hidden" : "";
    if (state) {
      var close = document.getElementById("cart-close");
      if (close) close.focus();
    }
  }

  function thumb(url) { return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=160"; }

  function esc(s) {
    return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  function render(cart) {
    var body = document.getElementById("drawer-body"),
        total = document.getElementById("cart-total"),
        checkout = document.getElementById("cart-checkout"),
        drawer = root();
    setCount(cart.item_count);
    if (drawer) drawer.classList.toggle("is-empty", cart.item_count === 0);
    if (total) total.textContent = money(cart.total_price);
    if (checkout) checkout.disabled = cart.item_count === 0;
    if (!body) return;

    if (!cart.items.length) {
      var browse = conf("empty-cta", ""), browseHref = conf("empty-href", "/collections/all");
      body.innerHTML = '<p class="drawer-empty">' + esc(conf("empty", "Your cart is empty.")) + "</p>" +
        (browse ? '<a class="drawer-empty-cta" href="' + esc(browseHref) + '">' + esc(browse) + "</a>" : "");
      return;
    }

    var removeLabel = esc(conf("remove", "Remove"));

    body.innerHTML = cart.items.map(function (it) {
      var img = it.image
        ? '<img src="' + thumb(it.image) + '" alt="" width="60" height="60">'
        : '<span class="line-media-empty"></span>';
      var variant = it.variant_title && it.variant_title !== "Default Title"
        ? '<p class="line-variant">' + esc(it.variant_title) + "</p>"
        : "";
      var name = esc(it.product_title);
      /* Une ligne que la remise a rendue gratuite : « Offert » et le nom de la
         remise, au lieu d'un « 0,00 € » qui ressemble à un oubli. Les données
         sont celles de /cart.js : final_line_price à 0 et au moins une remise
         sur la ligne (discounts, ou line_level_discount_allocations). */
      var disc = it.discounts && it.discounts.length
        ? it.discounts
        : (it.line_level_discount_allocations || []).map(function (a) {
            return { title: a.discount_application && a.discount_application.title };
          });
      var free = it.final_line_price === 0 && disc.length > 0;
      var offer = free && disc[0].title ? '<p class="line-offer">' + esc(disc[0].title) + "</p>" : "";
      var price = free
        ? '<p class="line-price line-price-free">' + esc(conf("free", "Offert")) + "</p>"
        : '<p class="line-price">' + money(it.final_line_price) + "</p>";
      return '<div class="line"><div class="line-media">' + img + '</div>' +
        '<div class="line-text"><p class="line-name">' + name + "</p>" + variant + offer +
        '<div class="qty">' +
        '<button class="qty-btn" type="button" data-key="' + it.key + '" data-qty="' + (it.quantity - 1) + '" aria-label="' + MINUS + '1 ' + name + '">' + MINUS + '</button>' +
        '<span class="qty-n">' + it.quantity + '</span>' +
        '<button class="qty-btn" type="button" data-key="' + it.key + '" data-qty="' + (it.quantity + 1) + '" aria-label="+1 ' + name + '">+</button>' +
        '</div></div>' +
        '<div class="line-right">' + price +
        '<button class="line-remove" type="button" data-key="' + it.key + '" data-qty="0">' + removeLabel + '</button>' +
        '</div></div>';
    }).join("");
  }

  function refresh(openAfter) {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); if (openAfter) open(true); })
      .catch(function () { if (openAfter) open(true); });
  }

  function change(key, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  window.qtOpenCart = function (cart) {
    if (cart && cart.items) { render(cart); open(true); } else { refresh(true); }
  };
  window.qtCloseCart = function () { open(false); };

  document.addEventListener("click", function (e) {
    var trigger = e.target.closest(".cart-btn, [data-cart-open]");
    if (trigger) { e.preventDefault(); refresh(true); return; }
    if (e.target.closest("#cart-close")) { open(false); return; }
    if (e.target.closest("#scrim")) { open(false); return; }
    var q = e.target.closest("#drawer-body [data-key]");
    if (q) change(q.getAttribute("data-key"), parseInt(q.getAttribute("data-qty"), 10));
  });

  document.addEventListener("keydown", function (e) {
    var drawer = root();
    if (e.key === "Escape" && drawer && drawer.classList.contains("on")) open(false);
  });

  if (root()) refresh(false);
})();
